import { Stack } from '@fluentui/react/lib/Stack';
import { PrimaryButton } from "office-ui-fabric-react";
import React from "react";

const UploadButton = (props) => {

  return (<Stack vertical className="mt-1" >
        <PrimaryButton >
            <label for={props.name} style={{width:"100%", height:"100%", lineHeight:"200%", cursor:"pointer"}}>
                {props.label}
            </label>
          </PrimaryButton>
      <input type="file" name={props.name} id={props.name} accept={props.accept} style={{visibility:"hidden"}} onChange={props.onChange} />
      </Stack>);
};

export default UploadButton;
